<section class="container d-flex flex-column justify-content-center min-vh-100 py-5">
  <ng-lottie [options]="animationOptionsLight" class="d-dark-mode-none mt-n5"></ng-lottie>
  <ng-lottie [options]="animationOptionsDark" class="d-none d-dark-mode-block mt-n5"></ng-lottie>
  <div class="text-center pt-4 mt-lg-2">
    <h1 class="display-5">Pagina inexistenta</h1>
    <p class="fs-lg pb-2 pb-md-0 mb-4 mb-md-5">Ai accesat un link ce nu este valabil sau pagina nu mai este de
      actualitate.</p>
    <a [routerLink]="['/']" class="btn btn-lg btn-primary">Pagina principala</a>
  </div>
</section>
